import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import useToggleHandler from 'hooks/useToggleHandler'
import { _isTeacher, _userId } from 'store/selectors/User'
import { _ttmMsg } from 'store/selectors/WebSocket'

import MaxStats from './components/MaxStats'
import MinStats from './components/MinStats'
import Progress from './components/Progress'
import useDataSender from './hooks/useDataSender'
import useTalktimePercentage from './hooks/useTalktimePercentage'
// import { ttmMsg, userId, userType } from './mocks'
import { Container } from './styles'

const TalktimeMonitor = () => {
    const ttMonitor = useRef()

    const userId = useSelector(_userId)
    const ttmMsg = useSelector(_ttmMsg)
    const isTeacher = useSelector(_isTeacher)

    useDataSender({ userId })

    const { open: openMinStats, toggle: toggleMinStats } = useToggleHandler(
        ttMonitor
    )

    const [openMaxStats, setOpenMaxStats] = useState(false)
    const toggleMaxStats = () => setOpenMaxStats(!openMaxStats)

    const percentage = useTalktimePercentage({
        userId,
        isTeacher,
        ttmMsg,
    })

    const commonProps = {
        userId,
        isTeacher,
        ...percentage,
    }

    const minStats = {
        ...commonProps,
        students: [...(ttmMsg?.message.students || [])],
        onClick: () => {
            toggleMinStats()
            toggleMaxStats()
        },
    }

    const maxStats = {
        ...commonProps,
        ttmData: { ...ttmMsg?.message },
        onClick: toggleMaxStats,
    }

    return (
        <>
            <Container ref={ttMonitor}>
                <Progress onClick={toggleMinStats} {...commonProps} />
                {openMinStats ? <MinStats {...minStats} /> : null}
            </Container>
            {openMaxStats ? <MaxStats {...maxStats} /> : null}
        </>
    )
}

export default TalktimeMonitor
